/** @type {Array<{ type: string, label: string }>} */
export const relationTypes = [

    { type: 1, typeName: 'self', label: '个人' },
    { type: 2, typeName: 'inpatient', label: '对公' },



];